import { Component, OnInit, Input } from '@angular/core';

import * as _ from 'lodash';

@Component({
  selector: 'app-loader-text',
  templateUrl: './loader-text.component.html',
  styleUrls: ['./loader-text.component.css']
})
export class LoaderTextComponent implements OnInit {

  itemRepeat = [0];

  constructor() { }

  @Input()
  set bloques(numBloques: number) {
    this.itemRepeat = _.times(numBloques);
  }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /app/src/app/components/loaders/loader-text/loader-text.component.ts